import { Icon } from '@iconify/react';

import * as S from './styles';
import Avatar from 'base/src/components/Avatar';
import Divider from 'base/src/components/Divider';
import { useTheme } from 'base/src/utils/context/themeContext';
import { formatToBRL } from 'base/src/utils/mathUtil';
import { formatCPF } from 'base/src/utils/stringUtil';
import StringUtil from 'domain/utils/StringUtils';

type Props = {
  nome: string;
  avatarUrl: string;
  cpf: string;
  premiacao: string;
  email: string;
  pix: string;
  valor: number;
  isRemoving?: boolean;
  validPix: boolean;
  remove?: () => void;
}

export function PagamentoDestinoCard ({ avatarUrl, cpf, premiacao, email, pix, valor, isRemoving, remove, nome, validPix }: Props){
  const { theme } = useTheme();

  return (
    <S.Container isRemoving={isRemoving}>
      <S.Title>{nome}</S.Title>
      <S.ContentContainer>
        <S.IconContainer>
          <Icon icon='mdi:trash' onClick={remove} cursor={'pointer'} color={theme.colors.negative} height={20} />
        </S.IconContainer>
        <Avatar
          src={avatarUrl}
          borderColor={theme.colors.primary}
          size='md'
          alt='top'
          fallBack={StringUtil.GetFirstLetters(nome)}
        />
        <S.ContainerInfo>
          <S.InfoLeft>
            <S.Info>
              <S.InfoTitle>CPF: </S.InfoTitle>
              <S.Subtitle>{formatCPF(cpf)}</S.Subtitle>
            </S.Info>
            <S.Info>
              <S.InfoTitle>Premiação: </S.InfoTitle>
              <S.Subtitle>{premiacao} </S.Subtitle>
            </S.Info>
          </S.InfoLeft>
          <S.InfoLeft>
            <S.Info>
              <S.InfoTitle warning={validPix}>PIX: </S.InfoTitle>
              {!pix ?
                <S.Subtitle warning={validPix}>Não informada</S.Subtitle>
                :
                <S.Subtitle warning={validPix}>{pix}</S.Subtitle>
              }
              {!validPix && (<Icon icon='si:alert-fill' height={20} color={theme.colors.negative} />)}
            </S.Info>
            <S.Info>
              <S.InfoTitle>Email: </S.InfoTitle>
              <S.Subtitle>{email}</S.Subtitle>
            </S.Info>
          </S.InfoLeft>
          <S.InfoLeft>
            <S.Info>
              <S.InfoTitle>Valor Resgate </S.InfoTitle>
            </S.Info>
            <S.Info>
              <S.Subtitle blue>{formatToBRL(valor)}</S.Subtitle>
            </S.Info>
          </S.InfoLeft>
        </S.ContainerInfo>
      </S.ContentContainer>
      <Divider orientation='horizontal' decorative color={theme.colors.border_grey} />
    </S.Container>
  )
}
